module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/pages/cerba/pages/admin/admin.component.html
// module id = ../../../../../src/app/pages/cerba/pages/admin/admin.component.html
// module chunks = 0